var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 22H8C8 22 1.962 21.38 2 16C2.021 12.96 4.688 10.18 8 10C8 5.86 10.65 2 15 2C18.433 2 20.723 4.1 21.538 7.01C26.493 6.8 29.844 10.72 30 14C30.135 16.83 27.68 20.48 25 22ZM23.067 5.03C21.599 2.05 18.543 0 15 0C10.251 0 6.37 3.68 6.033 8.34C2.542 9.34 0 12.39 0 16C0 20.26 3.54 23.73 8 23.98L25 24C28.437 22.51 32 18.35 32 14.5C32 9.44 28.049 5.32 23.067 5.03ZM21.295 12.39L17 16.66V7.01C17 6.46 16.553 6.01 16 6.01C15.448 6.01 15 6.46 15 7.01V16.63L10.736 12.39C10.344 12 9.707 12 9.313 12.39C8.921 12.78 8.921 13.41 9.313 13.81L15.254 19.72C15.464 19.93 15.741 20.02 16.016 20C16.29 20.02 16.568 19.93 16.777 19.72L22.718 13.81C23.11 13.41 23.11 12.78 22.718 12.39C22.325 12 21.688 12 21.295 12.39Z",
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.b0cb0726f1e367288820ff4be0ccb6f0.svg";
export { ForwardRef as ReactComponent };